

import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import { IQueryParams } from "queries";
import helpers from "helpers/index";
import queryClient from 'queries';



interface TypedTrip_schedule {
    id?: string | bigint;
    journey_id?: string | bigint;
    valid_from?: string;
    valid_to?: string;
    createdAt?: string | bigint;
}


type IQuery = TypedTrip_schedule & IQueryParams;


/*
* List of all app
*/
export function useGetTripSchedules(object: IQuery) {
    const EndURL = helpers.buildEndUrl(object);
    return useQuery({
        queryKey: ["trip_schedule/fetch_entity_list"],
        queryFn: () => axios.get<TypedTrip_schedule[]>(`/trip_schedule${EndURL}`).then(response => {
            let { data, headers } = response;
            return {
                body: data,
                totalItems: Number(headers['x-total-count'] || 0)
            }
        }),
        retry: 1,
        enabled: true,
    });
}

export function useGetTripSchedule(trip_template_id: string) {
    return useQuery({
        queryKey: ['trip_schedule/fetch_entity'],
        queryFn: () => axios.get<TypedTrip_schedule>(`/trip_schedule/${trip_template_id}`).then((response) => response.data),
        retry: 1,
        // enabled: false,
    });
}


export function useMutateGetTripSchedule() {
    return useMutation({
        mutationKey: ['trip_schedule/fetch_entity'],
        mutationFn: (trip_template_id: any) => axios.get<TypedTrip_schedule>(`/trip_schedule/${trip_template_id}`).then((response) => response.data),
    });
}


export function useUpdateTripSchedule() {
    return useMutation({
        mutationKey: ['trip_schedule/update_entity'],
        mutationFn: ({ id, ...rest }: TypedTrip_schedule) => axios.patch<TypedTrip_schedule>(`/trip_schedule/${id}`, helpers.cleanEntity(rest)).then((response) => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['trip_schedule/fetch_entity_list'] });
            queryClient.invalidateQueries({ queryKey: ['trip_schedule/fetch_entity'] });
        }
    });
}


export function useMutateCreateTripSchedule() {
    return useMutation({
        mutationKey: ['trip_schedule/create_entity'],
        mutationFn: (entity: TypedTrip_schedule) => axios.post<TypedTrip_schedule>(`/trip_schedule`, helpers.cleanEntity(entity)).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['trip_schedule/fetch_entity_list'] });
        }
    });
}

export function useMutateDeleteTripSchedule() {
    return useMutation({
        mutationKey: ['trip_schedule/delete_entity'],
        mutationFn: (id: any) => axios.delete<TypedTrip_schedule>(`/trip_schedule/${id}`).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['trip_schedule/fetch_entity_list'] });
        }
    });
}